import { Controller } from '@hotwired/stimulus';
import { post } from '@rails/request.js';

export default class extends Controller {
  static targets = ['localeSelect'];

  connect() {
    this.localeSelectTarget.addEventListener('change', this.handleChange);
  }

  disconnect() {
    this.localeSelectTarget.removeEventListener('change', this.handleChange);
  }

  handleChange = async (event) => {
    const url = event.target.value;
    if (!url) return;

    const response = await post(url);

    if (response.ok) {
      window.location.reload();
    }
  };
}
